<template>
    <div class="tools-browser container">
        <div v-if="loaded" class="md:flex">
            <aside class="md:h-full">
                <div class="container mx-auto md:px-0">
                    <div class="py-6 px-6 sm:px-0 sm:flex md:block">
                        <div v-if="keywords.length" class="mb-8 w-1/2">
                            <h5 class="mb-4 font-bold text-2xl" v-text="$options.filters['lang']('copy.keywords') + ':'"></h5>
                            <ul class="text-base">
                                <li v-for="item in keywords">
                                    <button
                                            @click="action('setKeyword', item.object.id)"
                                            class="py-5 flex flex-row items-center outline-none"
                                    >
                                        <span class="text-5xl flex-shrink-0 mr-4" :class="getKeywordIcon(item.object.id)"></span>
                                        <span class="flex-grow-1 text-left font-semibold" v-text="item.object.keyword"></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div v-if="languages.length" class="w-1/2">
                            <h5 class="mb-6 font-bold text-2xl" v-text="$options.filters['lang']('copy.languages') + ':'"></h5>
                            <ul class="text-base">
                                <li v-for="item in languages"><button @click="action('setLanguage', item.object.symbol)" class="btn font-bold py-3 outline-none" :class="getLanguageClass(item.object.symbol)" v-text="item.object.name"></button></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </aside>
            <main>
                <div class="container mx-auto md:px-0 md:mx-0">
                    <div>
                        <div class="-mx-2" :class="{'opacity-50 pointer-events-none': (status === 'loading')}">
                            <Tool v-for="item in items" :key="item.id" :value="item"></Tool>
                        </div>

                        <div v-if="status === 'loading'" class="loading text-center py-4">
                            <loading-animation></loading-animation>
                        </div>
                    </div>
                </div>
            </main>
        </div>
        <div v-else>
            <div v-if="status === 'loading'" class="loading text-center py-4">
                <loading-animation></loading-animation>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    let token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }

    import Tool from "./Tool";
    export default {
        name: "ToolsBrowser",
        components: {Tool},
        data() {
            return {
                status: null,
                loaded: false,
                items: [],
                keywords: [],
                languages: [],
                keyword_id: null,
                language_id: null
            };
        },
        mounted() {
            this.status = 'idle';
            this.load();
        },
        methods: {
            load() {
                this.status = 'loading';
                let endpoint = '/api/tools';
                let params = [];

                if (this.keyword_id) {
                    params.push('k=' + this.keyword_id);
                }

                if (this.language_id) {
                    params.push('l=' + this.language_id);
                }

                if (params.length) {
                    endpoint += '?' + params.join('&');
                }

                axios.get(endpoint).then((response) => {
                    // handle success

                    this.items = response.data.data.items;
                    this.keywords = response.data.data.keywords;
                    this.languages = response.data.data.languages;
                    this.status = 'idle';
                    this.loaded = true;

                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).finally(function () {
                    // always executed
                });
            },
            onDataError() {
                console.error('data error');
            },
            action(action, params) {
                switch (this.status) {
                    case 'idle': {
                        return this.actionWhenIdle(action, params);
                    }
                }
            },
            actionWhenIdle(action, params) {
                switch (action) {
                    case 'setKeyword': {
                        this.keyword_id = (this.keyword_id === params) ? null : params;
                        break;
                    }
                    case 'setLanguage': {
                        this.language_id = (this.language_id === params) ? null : params;
                        break;
                    }
                }
            },
            getKeywordClass(keyword_id) {
                if (keyword_id === this.keyword_id) {
                    return 'text-white';
                }
            },
            getKeywordIcon(keyword_id) {
                const baseClass = (keyword_id === this.keyword_id) ?
                    'text-orange icomoon' :
                    'text-violet icomoon';

                switch (keyword_id) {
                    case 2: {
                        return 'icon-shape1 ' + baseClass;
                    }
                    case 5: {
                        return 'icon-shape2 ' + baseClass;
                    }
                    case 4: {
                        return  'icon-shape3 ' + baseClass;
                    }
                    case 3: {
                        return  'icon-shape4 ' + baseClass;
                    }
                }
            },
            getLanguageClass(language_id) {
                if (language_id === this.language_id) {
                    return 'text-orange';
                }
            }
        },
        watch: {
            keyword_id() {
                this.load();
            },
            language_id() {
                this.load();
            }
        }
    }
</script>

<style scoped>

</style>
